import React from 'react'
import ReactDOM from 'react-dom'
import 'index.css'
import App from 'components/App'
import 'res/strings/i18next'
//import { unregister } from './registerServiceWorker';
import { HelmetProvider } from 'react-helmet-async'
import { createTheme, ThemeProvider } from '@mui/material'

import store from './util/store'
import { Provider } from 'react-redux'

const theme = createTheme({
    typography: {
        h6: { fontFamily: 'Spartan Regular' },
        h5: { fontFamily: 'Spartan Regular' },
        subtitle1: { fontFamily: 'Noto Sans, Noto Sans KR' },
        subtitle2: { fontFamily: 'Noto Sans, Noto Sans KR' },
        caption: { fontFamily: 'Noto Sans, Noto Sans KR' },
    },
    palette: {
        //기본 배경값
        background: {
            default: '#fafafa',
        },
    },
})

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <HelmetProvider>
                    <App />
                </HelmetProvider>
            </ThemeProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
)
//unregister()
